import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";

const API_URL = process.env.REACT_APP_API_URL;
const ROLES_URL = `${API_URL}/roles`;

export type ModulePermission = {
  view: boolean;
  create: boolean;
  edit: boolean;
  delete: boolean;
};

export type RolePermissions = Record<string, ModulePermission>;

export type RoleOption = {
  _id: string;
  name: string;
  slug: string;
};

export const getRoleOptions = createAsyncThunk(
  "getRoleOptions",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${ROLES_URL}/options`);
      return data;
    } catch (error: any) {
      const message =
        error.response?.data?.responseMessage || "Failed to fetch role options";
      notify(message, "error");
      return rejectWithValue(message);
    }
  }
);

export const getRoles = createAsyncThunk(
  "getRoles",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${ROLES_URL}/list`);
      return data;
    } catch (error: any) {
      const message =
        error.response?.data?.responseMessage || "Failed to fetch roles";
      notify(message, "error");
      return rejectWithValue(message);
    }
  }
);

export const getRoleById = createAsyncThunk(
  "getRoleById",
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${ROLES_URL}/${id}`);
      return data;
    } catch (error: any) {
      const message =
        error.response?.data?.responseMessage || "Failed to fetch role details";
      notify(message, "error");
      return rejectWithValue(message);
    }
  }
);

export const updateRolePermissions = createAsyncThunk(
  "updateRolePermissions",
  async (
    payload: { id: string; permissions: RolePermissions },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.put(
        `${ROLES_URL}/${payload.id}/permissions`,
        { permissions: payload.permissions }
      );
      notify(
        data.responseMessage || "Role permissions updated successfully",
        "success"
      );
      return data;
    } catch (error: any) {
      const message =
        error.response?.data?.responseMessage ||
        "Failed to update role permissions";
      notify(message, "error");
      return rejectWithValue(message);
    }
  }
);
